import i18n from "@/i18n";

export enum BrokerType {
  Residential = "Residential",
  Commercial = "Commercial",
  ResidentialAndCommercial = "ResidentialAndCommercial"
}

export class BrokerTypeHelper {
  static values(): string[] {
    return Object.keys(BrokerType).filter((item) => isNaN(Number(item)))
  }

  static brokerTypeNameAndLabel(): any[] {
    return this.values().map((brokerTypeKey: string) => {
      return {
        name: this.getBrokerTypeValueOfKey(brokerTypeKey),
        label: i18n.t(`organization.brokerTypes.${brokerTypeKey.makeFirstLetterLowercase()}`)
      }
    });
  }

  static getBrokerTypeValueOfKey(key: string) {
    // eslint-disable-next-line
    return Object.entries(BrokerType).find(([k, _]) => k.toUpperCase() === key.toUpperCase())?.[1]
  }
}